import {
	type OptimizelyUserContext,
	createInstance,
	setLogger,
} from '@optimizely/optimizely-sdk'
import type { Session } from 'session/src/types/session'
import type { Datafile, UserContext } from 'types/featureFlag'
import type { MasterData } from 'types/masterData'
import { getCookie } from 'utils/cookies/getCookie'
import { flattenObject } from 'utils/flattenObject'

import { CLIENT_ID_COOKIE } from '../constants'
import { parseMasterData } from './parseMasterData'

setLogger(null)

let userContext: OptimizelyUserContext | null

export const getUserContext = (): UserContext => userContext

interface CreateUserContextProps {
	datafile: Datafile
	masterdata: MasterData
	session: Session
}
export const createUserContext = ({
	datafile,
	masterdata,
	session,
}: CreateUserContextProps): void => {
	const featureFlagService = createInstance({
		datafile,
	})
	if (featureFlagService) {
		const clientId = getCookie(CLIENT_ID_COOKIE)
		if (clientId) {
			userContext = featureFlagService.createUserContext(clientId, {
				...JSON.parse(
					JSON.stringify(
						flattenObject({
							...parseMasterData(masterdata),
							logged: session.logged,
						})
					)
				),
			})
		}
	}
}
